export default __webpack_public_path__ + "static/media/b5.3644c216.jpg";